import { rupees } from "../Insights/format";

const PARTS = [
  ["paid_online", "Online", "online"],
  ["paid_from_wallet", "Wallet", "wallet"],
  ["cash_collected", "Cash", "cash"],
];

const paid = (row, key) => Number(row[key]) > 0;

const asOrderType = (row, refund) => ({ label: row.payment, tone: String(row.payment).toLowerCase(), refund });

export const paymentSplit = (row) => {
  const refund = paid(row, "refunded_to_wallet") ? `${rupees(row.refunded_to_wallet)} back to wallet` : null;
  const parts = PARTS.filter(([key]) => paid(row, key));
  if (parts.length === 0) return asOrderType(row, refund);
  if (parts.length === 1 && !refund) return { label: parts[0][1], tone: parts[0][2], refund };
  return {
    label: parts.map(([key, name]) => `${name} ${rupees(row[key])}`).join(" + "),
    tone: parts.length === 1 ? parts[0][2] : "mixed",
    refund,
  };
};
